import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const OverlayLoader = ({ isLoading, children, sx ={} }) => (
  <Box sx={[{ position: 'relative' }, sx]}>
    {children}

    {isLoading && (
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10,
          pointerEvents: 'none',
        }}
      >
        <CircularProgress />
      </Box>
    )}
  </Box>
);

export default OverlayLoader;
